namespace $.$$ {

	;$shm_hitalama_lib_tg_toHTML

	export class $shm_hitalama_map_widget_float_posts extends $.$shm_hitalama_map_widget_float_posts {

		posts(): readonly ( any )[] {
			// return this.data().messages.map( (m: any, i: number) => {
			return this.data().map( (m: any, i: number) => {
				return this.Post( i )
			} )
		}

		post_text( i: any ): string {
			return this.data()[ i ]
			// return this.data().messages[ id ].content.text.text
		}

		Post_dom( i: any ) {
			const div = document.createElement("div");
			div.innerHTML = this.post_text( i )
			return div
		}
		
		@ $mol_mem
		font_size( next?: number ) {
			return this.widget().Font_size(next)?.val(next) ?? 14
		}

		@ $mol_mem
		font_size_px() {
			return this.font_size() + 'px'
		}
		
		@ $mol_mem
		code( next?: string ): string {
			return this.widget().text( next ) ?? ''
		}

		@ $mol_mem
		code_result() {
			return this.map().execute( this.code(), { [ '$' + 'page' ]: this.Map_page(), [ '$' + 'this_widget' ]: this.widget(), [ '$' + 'view' ]: this } )
		}

		data() {
			return this.code_result() as any
			// return this.widget().data()
		}

	}
}
